import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const stepsHeaderStyles = css`
	margin: 0;
	${strictBreakpoints.onlyDesktop} {
		margin-top: 46px;
	}
	${strictBreakpoints.onlyTablet} {
		margin-top: 64px;
	}
	${strictBreakpoints.onlyMobile} {
		margin-top: 40px;
	}
`;
